import dashboard from './dashboard'

export default {
  namespaced: true,
  modules: { dashboard }
}
